"use strict";
var $25865e9d3dfe9009$var$attempts = 0;
var $25865e9d3dfe9009$var$whenComplete = function whenComplete() {
    if (++$25865e9d3dfe9009$var$attempts > 30) return;
    $25865e9d3dfe9009$var$attempts += 1;
    if (document.readyState === "complete") {
        $(function() {
            $.fn.isInViewport = function() {
                var elementTop = $(this).offset().top;
                var elementBottom = elementTop + $(this).outerHeight();
                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            };
            $("[data-aos]").each(function() {
                if ($(this).isInViewport()) $(this).removeAttr("data-aos");
            });
            // Initialise plugins
            AOS.refreshHard();
            AOS.init({
                startEvent: "scroll"
            });
            // magnificPopup Einzelbild und Galerie
            $("a.lightbox").magnificPopup({
                type: "image",
                closeOnContentClick: true,
                tLoading: "Loading image #%curr%...",
                mainClass: "mfp-img-mobile",
                gallery: {
                    enabled: true
                },
                image: {
                    titleSrc: function titleSrc(item) {
                        var title = "";
                        var img = item.el.find("img");
                        var a_title = img.attr("title");
                        if (typeof a_title != "undefined" && a_title.length > 0) title = a_title + " ";
                        if (img.length > 0 && img.attr("data-description")) title += img.attr("data-description");
                        return title;
                    }
                }
            });
            // Global variables
            var resizeWindowTimer;
            $("body").imagesLoaded(function() {
                $('[data-js="img-cover"]').imagefill();
            });
            // Burger button
            $('[data-js="burger-btn"]').on("click", function(e) {
                e.preventDefault();
                $(this).parent().parent().toggleClass("clicked");
            });
            // Nice select
            $(".cust-select").niceSelect();
            $(".cust-select .list li").on("click", function(e) {
                if ($(this).index() > 0) $(this).parent().parent().find(".current").addClass("current_bold");
                else $(this).parent().parent().find(".current").removeClass("current_bold");
            });
            // On window resize
            $(window).resize(function() {
                clearTimeout(resizeWindowTimer);
                resizeWindowTimer = setTimeout(function() {
                    mainNavPos($(".container").outerWidth());
                    // Main carousel dots position
                    if ($(window).innerWidth() > 767) $(".main-carousel .slick-dots").css({
                        "padding-right": ($(window).width() - $(".container").width()) / 2
                    });
                    else $(".main-carousel .slick-dots").removeAttr("style");
                }, 200);
            });
            // Main navigation position
            function mainNavPos(containerWidth) {
                if ($(window).innerWidth() < 992) $(".main-nav").css({
                    right: -($(window).innerWidth() - containerWidth) / 2
                });
                else $(".main-nav").removeAttr("style");
            }
            mainNavPos($(".container").outerWidth());
            // Panels
            $(".main-nav .main-nav__list .flyout__column-wrapper h4").on("click", function(e) {
                e.preventDefault();
                $(this).parent().toggleClass("collapsed");
            });
            $(".btn_go-top").on("click", function(e) {
                e.preventDefault();
                $("body, html").animate({
                    scrollTop: 0
                }, 500);
            });
            // Panels
            $(".panel-accordion .panel__title").on("click", function(e) {
                e.preventDefault();
                $(this).parents(".panel").toggleClass("collapsed");
            });
            $('[data-js="main-carousel"]').on("init", function(event, slick) {
                $(".main-carousel").slideDown(500, function() {
                    $(this).fadeTo(500, 1);
                });
            });
            // Carousels
            $('[data-js="main-carousel"]').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true,
                arrows: false
            });
            $('[data-js="content-carousel"]').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true,
                arrows: false
            });
            // $('[data-js="content-carousel"], [data-js="main-carousel"]').each().css({opacity: 1});
            if ($(window).innerWidth() > 767) $(".main-carousel .slick-dots").css({
                "padding-right": ($(window).width() - $(".container").width()) / 2
            });
            else $(".main-carousel .slick-dots").removeAttr("style");
            // Benutzernavigation laden
            if (typeof $(".ajax-login") !== "undefined" && $(".ajax-login").length > 0) $.ajax({
                url: "/user-nav.html",
                success: function success(response) {
                    if (response) $(".ajax-login").html(response);
                }
            });
            var newsFilterForm = $(".tx-as-news form.f_filter-2");
            if (typeof newsFilterForm !== "undefined" && newsFilterForm.length > 0) {
                var pid = $("#ncpid").eq(0).val();
                var selects = newsFilterForm.find("select");
                newsFilterForm.submit(function(event) {
                    var $this = $(this);
                    selects.each(function() {
                        var value = $(this).val();
                        var id = $(this).attr("id");
                        if ($("#hidden_" + id).length !== 0) $("#hidden_" + id).remove();
                        if (value > 0) {
                            var x = document.createElement("INPUT");
                            x.setAttribute("type", "hidden");
                            x.setAttribute("name", "tx_news_pi1[overwriteDemand][categories][]");
                            x.setAttribute("value", value);
                            x.setAttribute("id", "hidden_" + id);
                            $this.append(x);
                        }
                    });
                });
                var updateMaterialBadge = function updateMaterialBadge() {
                    $.ajax({
                        type: "POST",
                        url: "/news-ajax.html?cmd=filter",
                        data: newsFilterForm.serialize(),
                        success: function success(data) {
                            if (data) {
                                if (typeof data.news !== "undefined" && typeof data.news.found !== "undefined") {
                                    var text = "";
                                    text += data.news.found;
                                    if (data.news.found == 0) text = "Keine Ergebnisse";
                                    else if (data.news.found == 1) text += " Ergebnis anzeigen";
                                    else text += " Ergebnisse anzeigen";
                                    console.log(text);
                                    $("#material-badge").text(text);
                                }
                            }
                        },
                        statusCode: {
                            404: function _() {
                                alert("page not found");
                            }
                        }
                    });
                };
                updateMaterialBadge();
                selects.change(function() {
                    updateMaterialBadge();
                });
                var timeout;
                var newsFilterTerm = $("#news-subject");
                newsFilterTerm.keyup(function() {
                    if (timeout) clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        updateMaterialBadge();
                    }, 2000);
                });
                newsFilterTerm.autocomplete({
                    minLength: 2,
                    source: function source(request, response) {
                        var categories = [];
                        $(".tx-as-news form.f_filter-2 select").each(function() {
                            var value = $(this).val();
                            if (value > 0) categories.push(value);
                        });
                        request.tx_news_pi1 = {
                            ncpid: pid,
                            search: {
                                subject: request.term
                            },
                            overwriteDemand: {
                                categories: categories
                            }
                        };
                        $.getJSON("/news-ajax.html?cmd=autocomplete", request, function(data, status, xhr) {
                            response(data);
                        });
                    }
                });
            }
            var newsFilterFormHome = $(".tx-as-news form.f_filter");
            if (typeof newsFilterFormHome !== "undefined" && newsFilterFormHome.length > 0) $("#news-subject").autocomplete({
                minLength: 2,
                source: function source(request, response) {
                    var categories = [];
                    $(".tx-as-news form.f_filter select").each(function() {
                        var value = $(this).val();
                        if (value > 0) categories.push(value);
                    });
                    request.tx_news_pi1 = {
                        ncpid: $("#ncpid").eq(0).val(),
                        search: {
                            subject: request.term
                        },
                        overwriteDemand: {
                            categories: categories
                        }
                    };
                    $.getJSON("/news-ajax.html?cmd=autocomplete", request, function(data, status, xhr) {
                        response(data);
                    });
                }
            });
        });
        // Stop video on modal close
        if (typeof $(".video_modal") !== "undefined" && $(".video_modal").length > 0) {
            $(".video_modal").on("show.bs.modal", function() {
                var id = $(this).find(".video-js").attr("id");
                var myPlayer = videojs(id);
                var autoplay = myPlayer.autoplay();
                if (autoplay == true) myPlayer.play();
            });
            $(".video_modal").on("hide.bs.modal", function() {
                var id = $(this).find(".video-js").attr("id");
                var myPlayer = videojs(id);
                myPlayer.pause();
            });
        }
        var touchTester = {
            touchStarted: false,
            moveLimit: 5,
            moveCount: null,
            isSupported: "ontouchend" in document,
            isTap: function isTap(event) {
                if (!this.isSupported) return true;
                switch(event.originalEvent.type){
                    case "touchstart":
                        this.touchStarted = true;
                        this.moveCount = 0;
                        return false;
                    case "touchmove":
                        this.moveCount++;
                        this.touchStarted = this.moveCount <= this.moveLimit;
                        return false;
                    case "touchend":
                        var isTap = this.touchStarted;
                        this.touchStarted = false;
                        return isTap;
                    default:
                        return true;
                }
            }
        };
        $(".flyout").on("click touchstart touchmove touchend", "ul > li > a", function handleClick(event) {
            if (!touchTester.isTap(event)) return true;
        });
    } else setTimeout(function() {
        return whenComplete();
    }, 400);
};
$25865e9d3dfe9009$var$whenComplete();


//# sourceMappingURL=as-modern.js.map
